import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '全部分类', to: '/category' },
  { label: '热门榜单', to: '/category/all?sort=hot' },
  { label: '完本佳作', to: '/category/all?status=complete' },
  { label: '关于我们', to: '/about' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-background-100 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5" aria-label="57漫画网首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-2-fill h-5 w-5 text-background-50" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl font-bold text-foreground-900">57漫画网</span>
            </Link>
            <p className="mt-4 text-xs leading-6 text-foreground-600 md:text-sm">
              下拉式免费阅读漫画平台，海量韩漫与国产漫画高清在线看。无删减免费更新，并提供阅读元宇宙社交，在虚拟漫画咖啡馆中与同好交流阅读心得。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: 'ri-weibo-fill', label: '微博' },
                { icon: 'ri-qq-fill', label: 'QQ空间' },
                { icon: 'ri-wechat-fill', label: '微信公众号' },
                { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
              ].map((item) => (
                <a
                  key={item.icon}
                  href="#"
                  rel="nofollow"
                  aria-label={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${item.icon} h-4 w-4`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="快速导航">
            <h3 className="text-sm font-bold text-foreground-900 md:text-base">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-xs text-foreground-600 transition-colors hover:text-primary-600 md:text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门分类">
            <h3 className="text-sm font-bold text-foreground-900 md:text-base">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600 md:text-sm"
                  >
                    <i className={`${cat.icon} h-3.5 w-3.5 text-primary-500`} aria-hidden="true"></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold text-foreground-900 md:text-base">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-xs text-foreground-600 md:text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-2-line mt-0.5 h-4 w-4 text-primary-500" aria-hidden="true"></i>
                <span>北京市朝阳区建国路88号漫画大厦8层</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line h-4 w-4 text-primary-500" aria-hidden="true"></i>
                <a href="mailto:support@57mh.net" className="transition-colors hover:text-primary-600">
                  support@57mh.net
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line h-4 w-4 text-primary-500" aria-hidden="true"></i>
                <a href="tel:4008885757" className="whitespace-nowrap transition-colors hover:text-primary-600">
                  400-888-5757
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line h-4 w-4 text-primary-500" aria-hidden="true"></i>
                <span>客服时间：周一至周日 9:00 - 21:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-500 sm:flex-row md:px-6 md:text-sm">
          <p>© 2026 57漫画网 57mh.net 版权所有 · 京ICP备2026888888号-1</p>
          <div className="flex flex-wrap items-center gap-3">
            <Link to="/about" className="whitespace-nowrap transition-colors hover:text-primary-600">关于我们</Link>
            <Link to="/about" className="whitespace-nowrap transition-colors hover:text-primary-600">商务合作</Link>
            <a href="#" rel="nofollow" className="whitespace-nowrap transition-colors hover:text-primary-600">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}